<template>
    <div>
        <el-dialog :title="addList.id ? '编辑' : '添加'" width="35%" :visible.sync="dialogVisible" :before-close="handleClose">

            <el-form :model="addList" ref="addList" label-width="100px" class="demo-dynamic">
                <el-form-item label="商品分类" prop="categoryId" :rules="[
                    { required: true, message: '请输入商品名称', trigger: 'change' },
                ]">
                    <el-cascader placeholder="商品分类" style="width:100%" :options="options" filterable @focus="getClass"
                        :props="{ value: 'id', label: 'categoryName', children: 'childList' }" v-model="addList.categoryId"
                        class="goods-category"></el-cascader>
                </el-form-item>
                <el-form-item prop="goodsName" label="商品名称" :rules="[
                    { required: true, message: '请输入商品名称', trigger: 'blur' },
                ]">
                    <el-input v-model="addList.goodsName"></el-input>
                </el-form-item>
                <el-form-item prop="weight" label="重量(kg)" :rules="ruls1">
                    <el-input v-model="addList.weight"></el-input>
                </el-form-item>
                <el-form-item label="身高/尺寸" prop="specification" :rules="[
                ]">
                    <el-button @click="addDomain">增加选项</el-button>
                </el-form-item>
                <div style="margin-left:10%; display: flex; flex-wrap: wrap;">
                    <div v-for="(heigth, index) in addList.specification.heigth" :key="index">
                        <el-input type="text" v-model="addList.specification.heigth[index]"
                            style="width:60px; padding: 0;"></el-input>
                        <el-button @click.prevent="removeDomain(heigth)"
                            style=" color: red; font-size: 20px;line-height: 16px; height: 32px;position: relative ; top: 6px; text-align: center;  border: 0;">
                            <i class="el-icon-remove-outline"></i>
                        </el-button>
                    </div>
                </div>
                <el-form-item label="商品款式" prop="goodsModel" :rules="[
                    { required: true, message: '请选择商品款式', trigger: 'change' },
                ]">
                    <el-radio-group v-model="addList.goodsModel">
                        <el-radio :label="1">通用</el-radio>
                        <el-radio :label="0">男/女款</el-radio>
                        <!-- <el-radio label="2" >女款</el-radio> -->
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="goodsType" label="商品类型" :rules="[
                    { required: true, message: '请选择商品类型', trigger: 'blur' },
                ]">
                    <el-radio-group v-model="addList.goodsType">
                        <el-radio label="自有商品"></el-radio>
                        <el-radio label="推荐商品"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item prop="goodsOpen" label="是否开启" :rules="[
                    { required: true, message: '是否开启', trigger: 'blur' },
                ]">
                    <!-- <el-switch v-model="addList.goodsOpen" :active-value="1" :inactive-value="0"></el-switch> -->
                    <el-radio-group v-model="addList.goodsOpen">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>

                    </el-radio-group>
                </el-form-item>

                <!-- <el-form-item label="尺码表">
                    <el-upload :headers="{ 'authorization': 'Bearer ' + this.authorization }" class="upload-demo"
                        action="https://www.weidazhizao.com/uniform/admin/file/upload/else" accept=".png, .jpg"
                        :on-success="handleSuccess" :limit="1" :multiple="false" list-type="picture" ref="imgUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M</div>
                    </el-upload>
                    <img v-if="addList.sizePicture" :src="`https://www.weidazhizao.com/uniform/file` + addList.sizePicture"
                        alt="尺码表" style="width:100px;height:100px;margin-top:10px">
                </el-form-item> -->
                <el-form-item label="尺码表" prop="pictureUrl">
                    <el-button type="primary" @click="imageClassQuerySize">选择图片</el-button>
                    <div>
                        <img v-if="addList.sizePicture" :src="`${addList.sizePicture}`" alt=""
                            style="width:100px;height:100px;margin-top:10px">
                    </div>
                </el-form-item>
                <el-form-item label="封面图" prop="pictureUrl" :rules="[
                    { required: true, message: '请上传图片', trigger: 'blur' },
                ]">
                    <el-button type="primary" @click="imageQuery">选择图片</el-button>
                    <div>
                        <img v-if="addList.pictureUrl" :src="`${addList.pictureUrl}`" alt=""
                            style="width:100px;height:100px;margin-top:10px">
                    </div>
                </el-form-item>
                <el-form-item label="商品详情" prop="goodsAttribute" :rules="[
                    { required: true, message: '请输入商品详情', trigger: 'blur' },
                ]">
                    <!-- <RichText @RichText="RichText" ref="RichText" /> -->
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="addList.goodsAttribute">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- {{ addList.categoryId[0] }}{{ addList.categoryId[1] }} -->
                <el-button @click="cancelReset">取 消</el-button>
                <el-button type="primary" @click="SubmitForm1('addList')">确 定</el-button>
            </span>

        </el-dialog>

        <!-- 图片 -->

        <el-dialog title="选择图片" v-show="dialogTableVisible" :visible.sync="dialogTableVisible" append-to-body
            :before-close="handleClose1">
            <div v-show="addImg">
                <div style="display:flex;">
                    <div>
                        <el-row class="tac">
                            <el-menu default-active="1-1" class="el-menu-vertical-demo">
                                <el-menu-item index="1-1" @click="imageQuery">全部图片</el-menu-item>
                                <el-menu-item v-for="(item, index) in imageClass" :index="index.toString()" :key="index"
                                    :categoryCode="item.categoryCode" @click="imageClassQuery">{{
                                        item.categoryName
                                    }}</el-menu-item>
                            </el-menu>
                        </el-row>
                    </div>
                    <div class="imgdiv">
                        <div class="imgdiv-search">
                            <span class="imgdiv-search-span">图片名称:</span><el-input placeholder="请输入图片名称"
                                v-model="imgForm.pictureName" class="input-with-select" style="max-width: 300px">
                                <el-button slot="append" icon="el-icon-search" @click="imgName"></el-button>
                            </el-input>
                        </div>
                        <br>
                        <hr>
                        <div class="imgdiv-img">
                            <div class="imgdiv-img1" v-for="(item, index) in images" :key="index" :url="item.fileUrl"
                                @click="sty(index)" :class="(index === isIndex) ? 'active' : ''">
                                <img :src="item.fileUrl" :alt="item.pictureName">
                                <p>{{ item.pictureName }}</p>
                                <div class="cont">{{ item.pictureName }}</div>
                                <img src="../static/images/duihao2.png" alt="" class="select">
                            </div>

                        </div>
                        <div class="imgdiv-pag">
                                <el-pagination @current-change="handleCurrentChange" small layout="prev, pager, next"
                                    :total="total" :current-page.sync="imgForm.pageNum">
                                </el-pagination>
                                <!-- <el-button @click="previousPage"><i class="el-icon-arrow-left"></i></el-button>
                                <el-input style="width:60px; text-align: center; line-height: 32px;"
                                    v-model="imgForm.pageNum" @input="currentPage" @change="queryPage"></el-input>
                                <el-button @click="nextPage"><i class="el-icon-arrow-right"></i></el-button> -->
                            </div>
                    </div>
                </div>
                <div class="choose" style="display:flex;justify-content: space-between;">
                    <el-button type="primary" plain @click="(addImg = false)">上传图片</el-button>
                    <div>
                        <el-button @click="styCancel">取消</el-button>
                        <el-button type="primary" @click="styDetermine">确定</el-button>
                    </div>
                </div>
            </div>
            <div v-show="!addImg">
                <el-form :model="addList" ref="addList" label-width="100px" class="demo-dynamic">
                    <el-form-item label="商品分类" prop="categoryId" :rules="[
                        { required: true, message: '请输入商品名称', trigger: 'blur' },
                    ]">
                        <el-cascader placeholder="商品分类" :options="options" filterable @focus="getClass"
                            :props="{ value: 'id', label: 'categoryName', children: 'childList' }"
                            v-model="addList.categoryId" class="goods-category"></el-cascader>
                    </el-form-item>
                    <el-upload class="upload-demo" :action="Url + 'admin/file/upload'" accept=".png, .jpg"
                        :on-success="handleSuccess1" :limit="1" :multiple="false" list-type="picture"
                        :data="{ categoryId: this.addList.categoryId }" ref="imgUp"
                        :headers="{ 'authorization': 'Bearer ' + this.authorization }">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M</div>
                    </el-upload>
                </el-form>
                <el-button @click="(addImg = true)" class="but">返回</el-button>
            </div>
        </el-dialog>

        <!-- 尺码表 -->
        <el-dialog title="选择尺码表" v-show="dialogTableVisibleSize" :visible.sync="dialogTableVisibleSize" append-to-body
            :before-close="handleClose2">
            <div>
                <!-- <div v-for="item, index in imgSizeClassList" key="index" :url="item.fileUrl">
                    <img :src="item.fileUrl" alt="">
                </div> -->
                <div class="imgdiv-img">
                    <div class="imgdiv-img1" style="margin-bottom: 40px;" v-for="(item, index) in imgSizeClassList"
                        :key="index" :url="item.fileUrl" @click="stySize(index)"
                        :class="(index === isIndex) ? 'active' : ''">
                        <img :src="item.fileUrl" :alt="item.pictureName">
                        <p>{{ item.pictureName }}</p>
                        <div class="cont">{{ item.pictureName }}</div>
                        <img src="../static/images/duihao2.png" alt="" class="select">
                    </div>
                </div>

            </div>
            <div style="margin: 20px 0;">
                <el-upload class="upload-demo" :action="Url + 'admin/file/upload'" accept=".png, .jpg"
                    :on-success="handleSuccess2" :limit="1" :multiple="false" list-type="picture" :data="{ categoryId: 8 }"
                    ref="imgUpSize" :headers="{ 'authorization': 'Bearer ' + this.authorization }">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过5M</div>
                </el-upload>
            </div>
            <div style="text-align: right;">
                <el-button @click="styCancelSize">取消</el-button>
                <el-button type="primary" @click="styDetermineSize">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import request from '../utils/request'
import Url from '../Api/imagesUrl';
// import RichText from './RichText.vue';
export default {
    data() {
        return {
            Url,
            styDetermineImgSize: '',
            dialogTableVisibleSize: false,
            authorization: '',
            total: 0,
            dialogVisible: false,
            options: [],
            categoryName: '',
            addList: {
                id: '',
                categoryId: '',
                goodsName: '',
                weight: '',
                specification: {
                    heigth: []
                },
                sizePicture: '',
                pictureUrl: '',
                goodsAttribute: '',
                goodsType: '自有商品',
                goodsOpen: '0',
                goodsCode: '',
                goodsModel: ''
            },
            ruls1: [
                { required: true, message: '请输入商品重量', trigger: 'blur' },
                { pattern: /^-?(([0-9]*(\.[0-9]{1,3})$)|([0-9]+$))/, message: "请填写正确的商品重量", trigger: 'change' }
            ],
            dialogTableVisible: false,
            imageClass: [],
            images: [],
            imgForm: {
                categoryCode: '',
                pageNum: 1,
                pageSize: 12,
                pictureName: ''
            },
            isIndex: '',
            totalPage: '',
            styDetermineImg: '',
            addImg: true,
            imgSizeClass: {
                isPage: false,
                categoryCode: '0203'
            },
            imgSizeClassList: []
        };
    },
    components: {
        // RichText
    },
    created() {
        this.authorization = sessionStorage.getItem('authorization')
        this.getClass()
    },
    methods: {
        //尺码图片查询
        async imageClassQuerySize() {
            this.styDetermineImgSize = ''
            this.dialogTableVisibleSize = true
            const res = await request({
                method: 'POST',
                url: 'admin/picture/getPictureList',
                data: this.imgSizeClass
            })
            // console.log(res);
            if (res.code === '200') {
                this.isIndex = ''
                this.imgSizeClassList = res.data && res.data.list
            } else {
                this.$message.error(res.message);
            }
        },
        addGoods() {
            this.dialogVisible = true
            this.emptyList()
            this.addList.goodsOpen = 0
        },
        async SubmitForm1(addList) {

            this.$refs[addList].validate(async valid => {
                if (valid) {
                    if (this.addList.specification.heigth.length > 0) {
                        this.dialogVisible = false
                        const res = await request({
                            method: "POST",
                            url: 'admin/commodity/warehouse/addOrModify',
                            data: this.addList
                        })
                        //console.log(res);
                        this.dialogVisible = false
                        if (res.code === '200') {
                            this.$message.success(res.message)
                            this.$emit('reset')
                            this.$refs['imgUpload'].clearFiles()
                        } else {
                            this.$message.error(res.message)
                        }
                    } else {
                        this.$message.error('请填写身高尺寸')
                    }

                } else {
                    return false
                }
            })
        },
        //取消重置
        cancelReset() {
            this.dialogVisible = false
            this.$refs['imgUpload'].clearFiles()
        },
        //编辑商品
        async editorGoods(val) {
            this.dialogVisible = true
            this.addList.id = val
            const res = await request({
                method: "POST",
                url: 'admin/commodity/warehouse/findGoods',
                data: {
                    id: this.addList.id,
                    goodsType: '自有商品'
                }
            })
            if (res.code === '200') {
                let data = res.data.list[0]
                this.addList.id = data.id
                this.addList.categoryId = data.categoryId
                this.addList.goodsName = data.goodsName
                this.addList.specification = JSON.parse(data.specification)
                this.addList.sizePicture = data.sizePicture
                // let index = data.pictureUrl.indexOf('file')
                // let picture = data.pictureUrl.slice(index + 4)
                this.addList.pictureUrl = data.pictureUrl
                this.addList.goodsModel = data.goodsModel
                this.addList.goodsAttribute = data.goodsAttribute
                this.addList.goodsType = data.goodsType
                this.addList.goodsOpen = data.goodsOpen
                this.addList.goodsCode = data.goodsCode
                this.addList.weight = data.weight
                this.getClass()
            } else {
                this.$message.error(res.message)
            }


        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(() => {
                    if (this.$refs['imgUpload'] != undefined) {
                        this.$refs['imgUpload'].clearFiles()
                    }

                    done();
                })
                .catch(() => { });
        },
        // 删除上传文件
        handleClose1(done) {
            //console.log(111,this.$refs);
            //console.log(this.$refs['imgUp'] != undefined);
            if (this.$refs['imgUp'] != undefined) {
                this.$refs['imgUp'].clearFiles()
            }
            // console.log(222, this.$refs);
            done()
        },
        // 删除上传文件
        handleClose2(done) {
            //console.log(111,this.$refs);
            //console.log(this.$refs['imgUp'] != undefined);
            if (this.$refs['imgUpSize'] != undefined) {
                this.$refs['imgUpSize'].clearFiles()
            }
            // console.log(222, this.$refs);
            done()
        },
        //查询商品树
        async getClass() {
            const res = await request({
                method: "POST",
                url: "admin/category/tree",
            })
            // //console.log('res', res.data.length);
            for (let i = 0; i < res.data.length; i++) {
                // //console.log('i', i);
                for (let j = 0; j < res.data[i].childList.length; j++)
                    res.data[i].childList[j].childList = undefined
            }
            this.options = res.data
        },
        // 删除身高尺寸
        removeDomain(item) {
            let index = this.addList.specification.heigth.indexOf(item)
            if (index !== -1) {
                this.addList.specification.heigth.splice(index, 1)
            }
        },
        // 查询图片名称
        async imgName() {
            const res = await request({
                url: 'admin/picture/getPictureList',
                method: 'POST',
                data: this.imgForm
            })
            if (res.code === '200') {
                this.isIndex = ''
                this.styDetermineImg = ''
                this.images = res.data && res.data.list
            } else {
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        addDomain() {
            this.addList.specification.heigth.push('');
        },

        handleSuccess(file) {
            if (file.code === '200') {
                // let index = file.data.indexOf('file')
                // let picture = file.data.slice(index + 4)
                this.addList.sizePicture = file.data
            } else {
                this.$message.error(file.message)
            }
        },
        handleSuccess1(file) {
            if (file.code === '200') {
                if (this.$refs['imgUp'] != undefined) {
                    this.$refs['imgUp'].clearFiles()
                }
                // let index = file.data.indexOf('file')
                // let picture = file.data.slice(index + 4)
                this.addList.pictureUrl = file.data
                this.dialogTableVisible = false

            } else {
                this.$message.error(file.message)
            }
        },
        // 尺码表上传后
        handleSuccess2(file) {
            if (file.code === '200') {
                // console.log(1111);
                // let index = file.data.indexOf('file')
                // let picture = file.data.slice(index + 4)
                this.addList.sizePicture = file.data
                this.dialogTableVisibleSize = false
                this.$message.success(file.message)
                if (this.$refs['imgUpSize'] != undefined) {
                    this.$refs['imgUpSize'].clearFiles()
                }
            } else {
                this.$message.error(file.message)
            }
        },
        emptyList() {
            this.addList.id = ''
            this.addList.categoryId = ''
            this.addList.goodsName = ''
            this.addList.specification.heigth = []
            this.addList.sizePicture = ''
            this.addList.pictureUrl = ''
            this.addList.goodsAttribute = ''
            this.addList.goodsType = ''
            this.addList.goodsOpen = ''
            this.addList.goodsCode = ''
            this.addList.goodsModel = ''
            this.addList.weight = ''
        },
        //全部图片查询
        async imageQuery() {
            this.dialogTableVisible = true
            this.addImg = true
            this.imgForm.categoryCode = ''
            this.imgForm.pictureName = ''
            this.imgForm.pageNum = 1
            const res = await request({
                url: 'admin/category/tree',
                method: 'POST',
            })

            if (res.code === '200') {
                this.isIndex = ''
                this.styDetermineImg = ''
                //console.log(res);
                let arr = []
                res.data.forEach(v => {
                    v.childList.forEach(h => {
                        //console.log(h);
                        arr.push(h)
                    })
                });
                this.imageClass = arr
                const imgres = await request({
                    method: 'POST',
                    url: 'admin/picture/getPictureList',
                    data: this.imgForm
                })
                if (imgres.code === '200') {
                    //console.log(imgres);
                    //console.log(imgres.data.list);
                    this.images = imgres.data.list
                    this.totalPage = imgres.data.totalPage
                    this.total = imgres.data.total
                } else {
                    this.$message.error(imgres.message);
                }

            } else {
                this.$message.error(res.message);
            }
        },
        //图片分类查询
        async imageClassQuery(e) {
            //console.log(e.$attrs.categoryCode);
            this.imgForm.categoryCode = e.$attrs.categoryCode
            this.imgForm.pictureName = ''
            this.imgForm.pageNum = 1
            const res = await request({
                method: 'POST',
                url: 'admin/picture/getPictureList',
                data: this.imgForm
            })
            //console.log(res);
            if (res.code === '200') {
                this.isIndex = ''
                this.styDetermineImg = ''
                this.images = res.data.list
                this.totalPage = res.data.totalPage
                this.total = res.data.total
            } else {
                this.$message.error(res.message);
            }
        },
        //分页器
        async handleCurrentChange() {
            const res = await request({
                method: 'POST',
                url: 'admin/picture/getPictureList',
                data: this.imgForm
            })
            //console.log(res);
            if (res.code === '200') {
                this.isIndex = ''
                this.styDetermineImg = ''
                this.images = res.data.list
            } else {
                this.imgForm.pageNum = this.totaPage
                this.$message.error(res.message);

            }
        },
        //图片选中
        sty(index) {
            this.isIndex = index
            // //console.log(index,event.currentTarget.getAttribute("url"));
            // let idx = event.currentTarget.getAttribute("url").indexOf('file')
            //console.log(event.currentTarget.getAttribute("url").slice(idx + 4));
            // this.styDetermineImg = event.currentTarget.getAttribute("url").slice(idx + 4)
            this.styDetermineImg = event.currentTarget.getAttribute("url")
            //console.log(this.styDetermineImg, 111111111111);
        },
        // 尺码表选中
        stySize(index) {
            this.isIndex = index
            // //console.log(index,event.currentTarget.getAttribute("url"));
            // let idx = event.currentTarget.getAttribute("url").indexOf('file')
            //console.log(event.currentTarget.getAttribute("url").slice(idx + 4));
            // this.styDetermineImgSize = event.currentTarget.getAttribute("url").slice(idx + 4)
            this.styDetermineImgSize = event.currentTarget.getAttribute("url")
            //console.log(this.styDetermineImg, 111111111111);
        },
        //选中确定
        styDetermine() {
            if (this.styDetermineImg) {
                //console.log(this.styDetermineImg);
                this.addList.pictureUrl = this.styDetermineImg
                this.styDetermineImg = ''
                this.dialogTableVisible = false
                this.imageClass = []
            } else {
                this.$message.error('请先选择图片！')
            }

        },
        //尺码表选中确定
        styDetermineSize() {
            if (this.styDetermineImgSize) {
                //console.log(this.styDetermineImg);
                this.addList.sizePicture = this.styDetermineImgSize
                this.styDetermineImgSize = ''
                this.dialogTableVisibleSize = false
            } else {
                this.$message.error('请先选择图片！')
            }

        },
        // 取消选中
        styCancel() {
            //console.log(this);
            this.styDetermineImg = ''
            this.dialogTableVisible = false
            this.imageClass = []
        },
        // 尺码表取消选中
        styCancelSize() {
            //console.log(this);
            this.styDetermineImgSize = ''
            this.dialogTableVisibleSize = false
            // this.imageClass = []
        },
        // 下一页

        async nextPage() {
            //console.log(this.imgForm.pageNum);
            //console.log(this.totalPage);
            if (this.imgForm.pageNum + 1 <= this.totalPage) {
                this.imgForm.pageNum = this.imgForm.pageNum + 1
                const res = await request({
                    method: 'POST',
                    url: 'admin/picture/getPictureList',
                    data: this.imgForm
                })
                //console.log(res);
                if (res.code === '200') {
                    this.isIndex = ''
                    this.styDetermineImg = ''
                    this.images = res.data.list
                } else {
                    this.imgForm.pageNum = this.totaPage
                    this.$message.error(res.message);

                }
            } else {
                this.$message.error('最后一页')
            }
        },
        // 上一页
        async previousPage() {
            //console.log(this.imgForm.pageNum - 1);
            if (this.imgForm.pageNum - 1 >= 1) {
                this.imgForm.pageNum = this.imgForm.pageNum - 1
                const res = await request({
                    method: 'POST',
                    url: 'admin/picture/getPictureList',
                    data: this.imgForm
                })
                //console.log(res);
                if (res.code === '200') {
                    this.isIndex = ''
                    this.styDetermineImg = ''
                    this.images = res.data.list
                } else {
                    this.$message.error(res.message);
                }
            } else {
                return
            }
        },
        // 输入page
        currentPage() {
            //console.log(this.imgForm.pageNum);
            //console.log(this.totalPage);
            //console.log(this.imgForm.pageNum > this.totalPage);
            if (this.imgForm.pageNum > this.totalPage) {
                //console.log('totaPage');
                this.imgForm.pageNum = this.totalPage
            } else if (this.imgForm.pageNum < 1) {
                //console.log('pageNum');
                this.imgForm.pageNum = 1
            }
        },
        // 输入page查询
        async queryPage() {
            const res = await request({
                method: 'POST',
                url: 'admin/picture/getPictureList',
                data: this.imgForm
            })
            //console.log(res);
            if (res.code === '200') {
                this.isIndex = ''
                this.styDetermineImg = ''
                this.images = res.data.list
            } else {
                this.$message.error(res.message);
            }
        }
    },
    watch: {
        'addList.categoryId': {
            handler(newVal) {
                // //console.log(Array.isArray(newVal));
                if (Array.isArray(newVal)) {
                    this.addList.categoryId = newVal[1]
                }
                // 
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.goods-category {
    width: 500px;
}

.block {
    margin-left: 3%;
    margin-bottom: 20px;
}

.tac {
    width: 150px;
}

.imgdiv {
    flex: 1;
    padding-left: 20px;

    .imgdiv-search {
        display: flex;
        line-height: 32px;

        .imgdiv-search-span {
            margin-right: 20px;
        }
    }

    .imgdiv-img {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        // overflow: auto;
        // height: 400px;
        
        // height: 85%;

        .imgdiv-img1 {
            margin-right: 20px;
            margin-top: 10px;
            width: 100px;
            // background-color: red;
            // height: 130px;
            position: relative;
            border: 1px solid #75EBFD;
            // padding: 5px;
            margin-bottom: 30px;

            .select {

                width: 20px;
                height: 20px;
                position: absolute;
                top: 0;
                right: 0;
                display: none;
            }

            p {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
            }

            .cont {
                position: absolute;
                left: -50px;
                bottom: -40px;
                text-align: center;
                background-color: #e0e0e0;
                padding: 10px;
                width: 200px;
                display: none;
            }

            img {
                width: 90px;
                height: 90px;
            }
        }

        .imgdiv-img1:hover .cont {
            display: block;
        }

        .imgdiv-pag {
            position: absolute;
            bottom: 0;
            right: 10px;
            height: 20px;
        }
    }

    .choose {
        display: flex;
        justify-content: space-between;
    }


}
.imgdiv-img {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    height: 85%;

    .imgdiv-img1 {
        margin-right: 20px;
        margin-top: 10px;
        width: 100px;
        height: 130px;
        position: relative;
        border: 1px solid #75EBFD;
        padding: 5px;

        .select {

            width: 20px;
            height: 20px;
            position: absolute;
            top: 0;
            right: 0;
            display: none;
        }

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
        }

        .cont {
            position: absolute;
            left: -50px;
            bottom: -40px;
            text-align: center;
            background-color: #e0e0e0;
            padding: 10px;
            width: 200px;
            display: none;
        }

        img {
            width: 90px;
            height: 90px;
        }
    }

    .imgdiv-img1:hover .cont {
        display: block;
    }

    .imgdiv-pag {
        position: absolute;
        bottom: 0;
        right: 10px;
    }
}

.el-menu::v-deep {
    height: 500px;
    overflow: auto;
}

.active {
    .select {
        display: block !important;
    }
}

.but {
    position: absolute;
    right: 20px;
    bottom: 60px
}
</style>